(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-trustpilot"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aw-trustpilot-card')) {
    const desktop = window.matchMedia('(min-width: 1100px)');
    const pendingCards = new Set();
    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach(({ target, isIntersecting }) => {
            target.nearViewport = isIntersecting;
            target.activate();
          });
        }, { rootMargin: '300px 0px' })
      : null;

    const observeCard = (card) => {
      card.nearViewport = false;
      if (!desktop.matches) {
        observer?.unobserve(card);
        return;
      }
      if (observer) {
        observer.observe(card);
      } else {
        card.nearViewport = true;
        card.activate();
      }
    };

    const activatePendingCards = () => {
      pendingCards.forEach((card) => card.activate());
    };

    desktop.addEventListener('change', () => pendingCards.forEach(observeCard));
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(activatePendingCards, 0);
    }, { once: true });
    window.addEventListener('load', activatePendingCards, { once: true });
    document.addEventListener('load', (event) => {
      if (event.target.tagName === 'SCRIPT' && event.target.src.includes('widget.trustpilot.com/')) {
        activatePendingCards();
      }
    }, true);

    customElements.define('aw-trustpilot-card', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        pendingCards.add(this);
        observeCard(this);
      }

      disconnectedCallback() {
        pendingCards.delete(this);
        observer?.unobserve(this);
      }

      activate() {
        if (this.initialized || !this.isConnected || !desktop.matches || !this.nearViewport) return;
        if (document.readyState === 'loading' || !this.getClientRects().length) return;
        if (typeof window.Trustpilot?.loadFromElement !== 'function') return;
        const template = this.querySelector('template');
        const original = template?.content.firstElementChild;
        if (!original) return;
        const widget = original.cloneNode(true);
        this.append(widget);
        try {
          window.Trustpilot.loadFromElement(widget);
        } catch {
          widget.remove();
          return;
        }
        this.initialized = true;
        this.querySelector('.aw-trustpilot-fallback')?.remove();
        template.remove();
        pendingCards.delete(this);
        observer?.unobserve(this);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
